import React from 'react'

import get from 'get-value'

function DoctorIcons(props) {
	const matchIcon = (iconType, iconColor, customIcon) => {
		switch (iconType) {
			case 'star':
				return (
					<>
						<path
							d='M10.617 3.92469L7.53851 3.45617L6.16232 0.534604C6.12474 0.454613 6.0629 0.389859 5.98651 0.350498C5.79494 0.251462 5.56214 0.333992 5.46635 0.534604L4.09017 3.45617L1.01165 3.92469C0.926775 3.93739 0.849175 3.97929 0.789763 4.04277C0.717937 4.12008 0.678358 4.22408 0.679722 4.33193C0.681086 4.43979 0.723282 4.54266 0.797038 4.61794L3.02439 6.89197L2.49817 10.103C2.48583 10.1777 2.49372 10.2545 2.52095 10.3248C2.54818 10.395 2.59367 10.4559 2.65224 10.5004C2.71081 10.545 2.78013 10.5714 2.85234 10.5768C2.92454 10.5822 2.99675 10.5663 3.06076 10.5309L5.81434 9.0149L8.56791 10.5309C8.64309 10.5728 8.73039 10.5868 8.81405 10.5715C9.02502 10.5335 9.16689 10.324 9.13051 10.103L8.60429 6.89197L10.8316 4.61794C10.8923 4.55573 10.9323 4.47447 10.9444 4.38559C10.9771 4.16339 10.8292 3.9577 10.617 3.92469Z'
							fill={fill}
						/>
					</>
				)
			case 'clock':
				return (
					<>
						<path
							d='M6.35753 0.375C3.26555 0.375 0.761719 2.88443 0.761719 5.97641C0.761719 9.06839 3.26555 11.5778 6.35753 11.5778C9.45511 11.5778 11.9645 9.06839 11.9645 5.97641C11.9645 2.88443 9.45511 0.375 6.35753 0.375ZM8.60369 8.21698C8.55187 8.2689 8.49032 8.3101 8.42256 8.33821C8.3548 8.36632 8.28216 8.38078 8.20879 8.38078C8.13543 8.38078 8.06279 8.36632 7.99503 8.33821C7.92727 8.3101 7.86572 8.2689 7.8139 8.21698L5.97103 6.37411C5.9181 6.32223 5.876 6.26037 5.84715 6.1921C5.81831 6.12383 5.8033 6.05052 5.80299 5.97641V3.73585C5.80299 3.42777 6.05505 3.17571 6.36313 3.17571C6.67121 3.17571 6.92327 3.42777 6.92327 3.73585V5.74675L8.60369 7.42718C8.82215 7.64563 8.82215 7.99852 8.60369 8.21698Z'
							fill={fill}
						/>
					</>
				)
			case 'broken-heart':
				return (
					<>
						<path
							d='M15.6866 12.2549L14.3028 17.6099C14.2526 17.8041 14.1393 17.9761 13.9807 18.0989C13.8221 18.2217 13.6272 18.2884 13.4266 18.2884H13.419C13.2172 18.2867 13.0218 18.2178 12.8636 18.0924C12.7055 17.967 12.5938 17.7925 12.5461 17.5964L10.3408 8.47046L9.20032 11.6547C9.13743 11.8303 9.02185 11.9822 8.86938 12.0896C8.71691 12.1971 8.53499 12.2548 8.34848 12.2549H2.36719C5.22653 15.3768 13.5243 22.1224 13.5243 22.1224H13.579C13.579 22.1224 21.8775 15.3768 24.7385 12.2549H15.6866Z'
							fill='white'
						/>
						<path
							d='M7.70993 10.4452L9.65684 5.01027C9.72248 4.82684 9.84558 4.66949 10.0078 4.56164C10.1701 4.45379 10.3628 4.4012 10.5574 4.4117C10.7519 4.4222 10.9379 4.49522 11.0876 4.61991C11.2373 4.74459 11.3427 4.91427 11.3883 5.10371L13.4547 13.6522L14.1079 11.1237C14.1578 10.9292 14.271 10.7569 14.4296 10.6339C14.5883 10.511 14.7834 10.4443 14.9841 10.4444H26.0005C27.3119 7.83081 27.0014 4.66341 24.8381 2.49939C23.5587 1.22043 21.8237 0.501953 20.0146 0.501953C18.2056 0.501953 16.4706 1.22043 15.1912 2.49939L13.5776 4.11212L13.5507 4.08519L13.5229 4.11216L11.9102 2.49943C10.6311 1.22048 8.89637 0.501988 7.08757 0.501988C5.27876 0.501988 3.54403 1.22048 2.26494 2.49943C0.0999686 4.66345 -0.210588 7.83086 1.10082 10.4445H7.70996L7.70993 10.4452Z'
							fill={fill}
						/>
					</>
				)
			case 'user':
				return (
					<>
						<path
							d='M18.665 14C21.0154 15.2026 20.9553 17.9242 20.9553 17.9242C21.16 18.022 21.2958 18.2164 21.3698 18.3507C21.4218 18.4452 21.494 18.5253 21.5821 18.5836C22.6381 19.2831 23.2453 20.6455 23.2453 20.6455C23.3405 20.8053 23.3274 21.0028 23.3052 21.1266C23.2903 21.2079 23.2997 21.2917 23.3326 21.3667C23.4482 21.63 23.5282 21.9472 23.5832 22.2425C23.6613 22.6629 23.6974 23.0911 23.6974 23.5198V24.6328C23.6974 25.6773 22.4317 25.8514 22.4317 25.8514V25.8986H21.6182C21.2521 25.8986 20.9553 25.5869 20.9553 25.2024C20.9553 24.8179 21.2521 24.5062 21.6182 24.5062H22.4317V24.5378H22.6124V22.9241C22.6124 22.5998 22.4511 22.0719 22.3645 21.8124C22.3355 21.7253 22.2748 21.6559 22.1985 21.6105C21.9179 21.4438 21.7989 20.9937 21.7989 20.9937C21.6106 20.4903 21.2283 20.1404 20.9328 19.9317C20.7003 19.7678 20.3964 19.7678 20.164 19.9317C19.8687 20.1404 19.4861 20.4903 19.2979 20.9937C19.2979 20.9937 19.1789 21.4438 18.8985 21.6105C18.8219 21.6559 18.7612 21.7253 18.7322 21.8124C18.6457 22.0719 18.4843 22.5998 18.4843 22.9241V24.5378H18.665V24.5062H19.4788C19.8449 24.5062 20.1417 24.8179 20.1417 25.2024C20.1417 25.5869 19.8449 25.8986 19.4788 25.8986H18.665V25.8514C18.665 25.8514 17.3996 25.6773 17.3996 24.6328V23.5198C17.3996 23.0911 17.4354 22.6629 17.5139 22.2425C17.5688 21.9472 17.6488 21.63 17.7641 21.3667C17.7971 21.2917 17.8065 21.2079 17.7918 21.1266C17.7693 21.0028 17.7565 20.8053 17.8515 20.6455C17.8515 20.6455 18.4587 19.2831 19.5149 18.5836C19.6028 18.5253 19.6752 18.4452 19.7272 18.3507C19.801 18.2164 19.9367 18.022 20.1417 17.9242C19.9704 16.1869 18.7558 15.0422 17.8826 14.4336C17.4681 14.7033 17.0335 14.9401 16.5798 15.1416C15.4069 15.6626 14.1619 15.9268 12.8794 15.9268C11.597 15.9268 10.3522 15.6626 9.17913 15.1416C8.64801 14.9057 8.14278 14.6215 7.66553 14.2922C6.85303 14.9445 5.75444 16.0853 5.65219 17.5403C6.66762 17.8185 7.41919 18.7895 7.41919 19.9416C7.41919 21.3098 6.35904 22.4229 5.05622 22.4229C3.75339 22.4229 2.69325 21.3098 2.69325 19.9416C2.69325 18.7706 3.46992 17.7874 4.5102 17.5279C4.55282 17.158 4.80596 15.5747 6.11061 14.3123C3.90115 15.0724 -0.478039 17.5771 0.0426204 25.424C0.0426204 25.424 2.81223 28.9577 12.9098 28.9995V29C12.9399 29 12.9699 28.9997 13 28.9997C13.0303 28.9997 13.0601 29 13.0905 29V28.9995C23.1878 28.9577 25.9574 25.424 25.9574 25.424C26.6504 14.981 18.665 14 18.665 14'
							fill={fill}
						/>
						<path
							d='M3.65625 18.8533C3.65625 19.5708 4.32738 20.1545 5.15231 20.1545C5.97724 20.1545 6.64837 19.5708 6.64837 18.8533C6.64837 18.1358 5.97724 17.552 5.15231 17.552C4.32738 17.552 3.65625 18.1358 3.65625 18.8533Z'
							fill={fill}
						/>
						<path
							d='M13.1263 13.8376C17.5197 13.8376 21.0811 10.7399 21.0811 6.91892C21.0811 3.09767 17.5197 -4.18353e-05 13.1263 -4.18353e-05C8.73332 -4.18353e-05 5.17188 3.09767 5.17188 6.91892C5.17188 10.7399 8.73332 13.8376 13.1263 13.8376Z'
							fill={fill}
						/>
					</>
				)
			case 'calendar':
				return (
					<>
						<path
							d='M19.4857 24.3571H2.43571C1.09051 24.3571 0 23.2666 0 21.9214V4.87143C0 3.52622 1.09051 2.43571 2.43571 2.43571H4.87143V0H7.30714V2.43571H14.6143V0H17.05V2.43571H19.4857C20.8309 2.43571 21.9214 3.52622 21.9214 4.87143V21.9214C21.9214 23.2666 20.8309 24.3571 19.4857 24.3571ZM2.43571 9.74286V21.9214H19.4857V9.74286H2.43571ZM2.43571 4.87143V7.30714H19.4857V4.87143H2.43571ZM9.74286 19.9899L5.22826 15.4753L6.95031 13.7533L9.74286 16.5458L14.9711 11.3175L16.6932 13.0396L9.74286 19.9887V19.9899Z'
							fill={fill}
						/>
					</>
				)
			case 'availability':
				return (
					<>
						<path
							d='M14.2083 21.9583C14.2083 22.6687 14.7896 23.25 15.5 23.25C16.2104 23.25 16.7917 22.6687 16.7917 21.9583C16.7917 21.2479 16.2104 20.6667 15.5 20.6667C14.7896 20.6667 14.2083 21.2479 14.2083 21.9583ZM14.2083 3.875V9.04167H16.7917V6.56167C21.1704 7.19458 24.5417 10.9404 24.5417 15.5C24.5417 20.4987 20.4987 24.5417 15.5 24.5417C10.5012 24.5417 6.45833 20.4987 6.45833 15.5C6.45833 13.33 7.22042 11.3408 8.49917 9.79083L15.5 16.7917L17.3212 14.9704L8.53792 6.18708V6.21292C5.70917 8.33125 3.875 11.6896 3.875 15.5C3.875 21.9196 9.0675 27.125 15.5 27.125C21.9196 27.125 27.125 21.9196 27.125 15.5C27.125 9.08042 21.9196 3.875 15.5 3.875H14.2083ZM23.25 15.5C23.25 14.7896 22.6687 14.2083 21.9583 14.2083C21.2479 14.2083 20.6667 14.7896 20.6667 15.5C20.6667 16.2104 21.2479 16.7917 21.9583 16.7917C22.6687 16.7917 23.25 16.2104 23.25 15.5ZM7.75 15.5C7.75 16.2104 8.33125 16.7917 9.04167 16.7917C9.75208 16.7917 10.3333 16.2104 10.3333 15.5C10.3333 14.7896 9.75208 14.2083 9.04167 14.2083C8.33125 14.2083 7.75 14.7896 7.75 15.5Z'
							fill='url(#paint0_linear_788_10253)'
						/>
						<defs>
							<linearGradient
								id='paint0_linear_788_10253'
								x1='4.13252'
								y1='15.5'
								x2='27.125'
								y2='15.5'
								gradientUnits='userSpaceOnUse'>
								<stop stopColor='#F06426' />
								<stop offset='1' stopColor='#E21E29' />
							</linearGradient>
						</defs>
					</>
				)
			case 'award':
				return (
					<>
						<path
							d='M43.2057 38.7477V56.214C43.2058 56.4389 43.1462 56.6597 43.033 56.854C42.9198 57.0483 42.7571 57.2091 42.5615 57.3199C42.3658 57.4308 42.1443 57.4877 41.9195 57.485C41.6946 57.4823 41.4746 57.42 41.2817 57.3044L30.4974 50.8333L19.7131 57.3044C19.52 57.4201 19.2997 57.4824 19.0747 57.485C18.8496 57.4876 18.6279 57.4305 18.4322 57.3193C18.2365 57.2081 18.0739 57.047 17.9608 56.8523C17.8478 56.6577 17.7886 56.4365 17.7891 56.2115V38.7502C14.5005 36.1173 12.111 32.5279 10.9506 28.4782C9.79025 24.4284 9.91639 20.1183 11.3116 16.1433C12.7068 12.1683 15.3022 8.72488 18.7391 6.28877C22.176 3.85266 26.2847 2.54419 30.4974 2.54419C34.7101 2.54419 38.8188 3.85266 42.2557 6.28877C45.6926 8.72488 48.288 12.1683 49.6832 16.1433C51.0784 20.1183 51.2045 24.4284 50.0442 28.4782C48.8838 32.5279 46.4943 36.1173 43.2057 38.7502V38.7477ZM30.4974 38.125C34.5419 38.125 38.4208 36.5183 41.2808 33.6584C44.1407 30.7984 45.7474 26.9195 45.7474 22.875C45.7474 18.8304 44.1407 14.9515 41.2808 12.0916C38.4208 9.23167 34.5419 7.62498 30.4974 7.62498C26.4528 7.62498 22.5739 9.23167 19.714 12.0916C16.8541 14.9515 15.2474 18.8304 15.2474 22.875C15.2474 26.9195 16.8541 30.7984 19.714 33.6584C22.5739 36.5183 26.4528 38.125 30.4974 38.125ZM30.4974 33.0416C27.801 33.0416 25.2151 31.9705 23.3085 30.0639C21.4019 28.1573 20.3307 25.5713 20.3307 22.875C20.3307 20.1786 21.4019 17.5927 23.3085 15.6861C25.2151 13.7794 27.801 12.7083 30.4974 12.7083C33.1938 12.7083 35.7797 13.7794 37.6863 15.6861C39.5929 17.5927 40.6641 20.1786 40.6641 22.875C40.6641 25.5713 39.5929 28.1573 37.6863 30.0639C35.7797 31.9705 33.1938 33.0416 30.4974 33.0416Z'
							fill='url(#paint0_linear_788_10212)'
						/>
						<defs>
							<linearGradient
								id='paint0_linear_788_10212'
								x1='10.6145'
								y1='30.0146'
								x2='50.8307'
								y2='30.0146'
								gradientUnits='userSpaceOnUse'>
								<stop stopColor='#F06426' />
								<stop offset='1' stopColor='#E21E29' />
							</linearGradient>
						</defs>
					</>
				)
			case 'star-color':
				return (
					<>
						<path
							d='M29.3307 12.3201L19.7441 11.4934L15.9974 2.66675L12.2507 11.5067L2.66406 12.3201L9.94406 18.6267L7.7574 28.0001L15.9974 23.0267L24.2374 28.0001L22.0641 18.6267L29.3307 12.3201ZM15.9974 20.5334L10.9841 23.5601L12.3174 17.8534L7.89073 14.0134L13.7307 13.5067L15.9974 8.13341L18.2774 13.5201L24.1174 14.0267L19.6907 17.8667L21.0241 23.5734L15.9974 20.5334Z'
							fill='url(#paint0_linear_788_10228)'
						/>
						<defs>
							<linearGradient
								id='paint0_linear_788_10228'
								x1='2.95942'
								y1='15.3334'
								x2='29.3307'
								y2='15.3334'
								gradientUnits='userSpaceOnUse'>
								<stop stopColor='#F06426' />
								<stop offset='1' stopColor='#E21E29' />
							</linearGradient>
						</defs>
					</>
				)
			case 'quote':
				return (
					<>
						<path
							d='M60.2383 55.3203C66.0977 55.3203 73.2266 58.9336 81.625 66.1602C90.2188 73.1914 94.5156 83.25 94.5156 96.3359C94.5156 109.227 89.7305 121.043 80.1602 131.785C70.5898 142.527 59.1641 147.898 45.8828 147.898C32.6016 147.898 21.6641 144.09 13.0703 136.473C4.47656 128.855 0.179688 116.648 0.179688 99.8516C0.179688 83.0547 7.89453 63.8164 23.3242 42.1367C38.9492 20.457 56.8203 6.49219 76.9375 0.242188C83.5781 3.75781 87.1914 9.12891 87.7773 16.3555C80.5508 22.0195 74.2031 29.0508 68.7344 37.4492C63.4609 45.6523 60.6289 51.6094 60.2383 55.3203ZM165.121 55.3203C170.98 55.3203 178.109 58.9336 186.508 66.1602C195.102 73.1914 199.398 83.25 199.398 96.3359C199.398 109.227 194.613 121.043 185.043 131.785C175.473 142.527 164.047 147.898 150.766 147.898C137.484 147.898 126.547 144.09 117.953 136.473C109.555 128.855 105.355 118.406 105.355 105.125C105.355 91.8438 108.773 77.9766 115.609 63.5234C122.641 48.875 132.113 35.6914 144.027 23.9727C155.941 12.2539 168.637 4.34375 182.113 0.242188C188.754 3.95312 192.367 9.32422 192.953 16.3555C185.531 22.0195 179.086 29.0508 173.617 37.4492C168.344 45.6523 165.512 51.6094 165.121 55.3203Z'
							fill='url(#paint0_linear_1291_6570)'
							fillOpacity='0.2'
						/>
						<defs>
							<linearGradient
								id='paint0_linear_1291_6570'
								x1='-24.3861'
								y1='263'
								x2='209'
								y2='263'
								gradientUnits='userSpaceOnUse'>
								<stop stopColor='#F06426' />
								<stop offset='1' stopColor='#E21E29' />
							</linearGradient>
						</defs>
					</>
				)
			case 'physicalVisit':
				return <></>
			case 'videoConsult':
				return <></>
			default:
				undefined
		}
	}

	const className = get(props, 'className', '')
	const iconType = get(props, 'iconType', '')
	const iconColor = get(props, 'iconColor', '#000')
	const customIcon = get(props, 'customIcon', '')
	const width = get(props, 'width', '20px')
	const height = get(props, 'height', '')
	const viewBox = get(props, 'viewBox', '0 0 24 24')
	const onClick = get(props, 'onClick', {})
	const strokeColor = get(props, 'strokeColor', '')
	const strokeWidth = get(props, 'strokeWidth', '')
	const fill = get(props, 'fillColor', 'none')
	return (
		<svg
			className={className}
			viewBox={viewBox}
			stroke={strokeColor}
			strokeWidth={strokeWidth}
			fill={fill}
			onClick={onClick}
			style={{ width: width, height: height }}>
			{matchIcon(iconType, iconColor, customIcon)}
		</svg>
	)
}

export { DoctorIcons }
export default DoctorIcons
